import { render, staticRenderFns } from "./ListingItemEl.vue?vue&type=template&id=0c4c484c&scoped=true&"
import script from "./ListingItemEl.vue?vue&type=script&lang=ts&"
export * from "./ListingItemEl.vue?vue&type=script&lang=ts&"
import style0 from "./ListingItemEl.vue?vue&type=style&index=0&id=0c4c484c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c484c",
  null
  
)

export default component.exports